import { render, staticRenderFns } from "./BrandsIndexPage.vue?vue&type=template&id=95484a20&scoped=true&"
import script from "./BrandsIndexPage.vue?vue&type=script&lang=js&"
export * from "./BrandsIndexPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95484a20",
  null
  
)

export default component.exports